import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "_shared/_stores/redux-store";
import Guid from "_shared/guids/guid";
import DocumentQuerySchema, { DocumentQueryJSON } from "documents/_api/commands/_schema/document-query-schema";
import DocumentQuery from "documents/_api/queries/document-query";

export type DocumentError = {
  id: Guid;
  error: string;
};

export type DocumentStoreState = {
  interfaceQueries: {
    entries: Record<string, DocumentQueryJSON>;
  };
};

const initialState: DocumentStoreState = {
  interfaceQueries: {
    entries: {},
  },
};

export const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    updateDocumentsInterfaceQuery: (
      state,
      action: PayloadAction<{
        interfaceName: string;
        query: DocumentQuery;
      }>,
    ) => {
      const { interfaceName, query } = action.payload;
      state.interfaceQueries.entries[interfaceName] = DocumentQuerySchema.serialize(query);
    },
  },
});

export const { updateDocumentsInterfaceQuery } = documentsSlice.actions;

const selectDocumentsQueryByInterface = createSelector(
  [
    (state: RootState) => state.documents.interfaceQueries.entries,
    (_state: RootState, interfaceName: string) => interfaceName,
  ],
  (queries, interfaceName) => {
    const query = queries[interfaceName];
    return query ? DocumentQuerySchema.deserialize(query) : undefined;
  },
);

export const getDocumentsQueryByInterface = (interfaceName: string) => (state: RootState) =>
  selectDocumentsQueryByInterface(state, interfaceName);
